import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import ProductItem from './ProductItem';
import { bundleIds, BundleItemType } from './data';
import css from './index.module.scss';

const Bundles: React.FC = () => {
    const { locale = '' } = useRouter();
    const bundleId = bundleIds[locale] || [];
    const [bundles, setBundles] = useState<BundleItemType[]>([]);
    const { t } = useLang('Bundles');
    const productAll: { [key: string]: BundleItemType } = {};
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);

    const getAsynItem = async (productId: string, variantId: string): Promise<BundleItemType> => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    productAll[`${productId}-${variantId}`] = res.data;
                    return resolve(res.data);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    const initBundleData = async () => {
        const temp1 = bundleId.filter((item: BundleItemType) => item?.productId && item?.variantId);

        const promiseAll: Promise<BundleItemType>[] = [];
        const promiseObj: { [key: string]: boolean } = {};
        temp1.forEach((item: BundleItemType) => {
            if (item?.productId && item?.variantId && !promiseObj[`${item.productId}-${item.variantId}`]) {
                promiseAll.push(getAsynItem(item.productId, item.variantId));
                promiseObj[`${item.productId}-${item.variantId}`] = true;
            }
            if (item?.subs && item?.subs?.length > 0) {
                item.subs.forEach((subItem: BundleItemType) => {
                    if (subItem?.productId && subItem?.variantId && !promiseObj[`${subItem.productId}-${subItem.variantId}`]) {
                        promiseAll.push(getAsynItem(subItem.productId, subItem.variantId));
                        promiseObj[`${subItem.productId}-${subItem.variantId}`] = true;
                    }
                });
            }
        });
        await Promise.all(promiseAll);
        const cloneBundles = JSON.parse(JSON.stringify(bundleId));
        cloneBundles.forEach((item: BundleItemType, index: number) => {
            if (item?.productId && item?.variantId) {
                cloneBundles[index] = {
                    ...item,
                    ...productAll[`${item.productId}-${item.variantId}`],
                    power: t(`bundle${index + 1}_power`),
                    desc: t(`bundle${index + 1}_desc`),
                    name: t(`bundle${index + 1}_name`),
                    quantity: 1,
                    tip: t(`bundle${index + 1}_tip`),
                };
            }

            if (cloneBundles[index]?.subs?.length > 0) {
                cloneBundles[index].subs.forEach((subItem: BundleItemType, subIndex: number) => {
                    if (subItem?.productId && subItem?.variantId) {
                        cloneBundles[index].subs[subIndex] = {
                            ...subItem,
                            ...productAll[`${subItem.productId}-${subItem.variantId}`],
                            quantity: 0,
                            parentVariantId: item.variantId,
                        };
                    }
                });
            }
            if (item?.type === 'customize') {
                cloneBundles[index] = {
                    ...item,
                    productTitle: t('customize_title'),
                    link_buy: t('customize_link_buy'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1758004034199/dpux_bundle_customize.png',
                };
            }
        });
        setBundles(cloneBundles);
    };

    const handleCalc = (parentVariantId: string, variantId: string, type: 'plus' | 'minus') => {
        const [MIN, MAX] = [0, 100];
        const newBundles = JSON.parse(JSON.stringify(bundles));
        const targetParent: BundleItemType | undefined = newBundles.find((i: BundleItemType) => i.variantId === parentVariantId);
        if (targetParent && targetParent.subs && targetParent.subs?.length > 0) {
            const target: BundleItemType | undefined = targetParent.subs.find((i: BundleItemType) => i.variantId === variantId);
            if (target) {
                if (type === 'plus') {
                    if (target.inventoryPolicy === 'continue') {
                        target.quantity = Math.min((target?.quantity || 0) + 1, MAX);
                    } else {
                        target.quantity = Math.min((target?.quantity || 0) + 1, Math.min(target?.inventoryQuantity || 0, MAX));
                    }
                } else if (type === 'minus') {
                    target.quantity = Math.max((target.quantity || 0) - 1, MIN);
                }
            }
        }
        setBundles(newBundles);
    };

    useEffect(() => {
        initBundleData();
    }, [bundleId]);

    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);

    console.log('bundles', bundles);
    return (
        <div className={`${css['bundles']} bundles GtmModuleData-section`} data-section-id="Bundles">
            <section className="bundles-container">
                <p className="title">{t('title')}</p>
                <div className="bundles-box">
                    {bundles.map((item: BundleItemType, _: number) => (
                        <ProductItem
                            key={`${`${item?.parentVariantId ? `${item?.parentVariantId}-` : ''}`}${item.productId}-${item.variantId}`}
                            item={item}
                            callback={handleCalc}
                        />
                    ))}
                    {/* <Swiper
                        className="swiper-container"
                        slidesPerView="auto"
                        spaceBetween={spaceBetweenN}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={[Navigation]}
                    >
                        {bundles.map((item: BundleItemType, _: number) => (
                            <SwiperSlide key={`${`${item?.parentVariantId ? `${item?.parentVariantId}-` : ''}`}${item.productId}-${item.variantId}`}>
                                <ProductItem item={item} callback={handleCalc} />
                            </SwiperSlide>
                        ))}
                        <div className={`eco-swiper-control eco-swiper-control-white`}>
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div>
                    </Swiper> */}
                </div>
            </section>
        </div>
    );
};
export default Bundles;
